import { z } from 'zod';
import { idInput, paginationInput } from './common';

// Previsão Orçamentária
export const createPrevisaoInput = z.object({
  eventoId: z.string().uuid(),
  data: z.string(),
  contaGabaritoId: z.string().uuid('Selecione uma conta'),
  descricao: z.string().min(2, 'Descrição deve ter no mínimo 2 caracteres'),
  valor: z.string().min(1, 'Valor é obrigatório'),
});

export const updatePrevisaoInput = idInput.extend({
  data: z.string().optional(),
  contaGabaritoId: z.string().uuid().optional(),
  descricao: z.string().min(2).optional(),
  valor: z.string().optional(),
});

export const listPrevisaoInput = paginationInput.extend({
  eventoId: z.string().uuid(),
});

export const getComparativoInput = z.object({
  eventoId: z.string().uuid(),
});

// Types
export type CreatePrevisaoInput = z.infer<typeof createPrevisaoInput>;
export type UpdatePrevisaoInput = z.infer<typeof updatePrevisaoInput>;
export type ListPrevisaoInput = z.infer<typeof listPrevisaoInput>;
export type GetComparativoInput = z.infer<typeof getComparativoInput>;
